import { ErrorType } from '@dfl/mui-react-common';

export enum PRODUCT_OFFER_ERROR_REFERENCE {
  /** El alcance haria pasar del tope de zonas. `data: { zones, max }`. */
  ZONE_LIMIT = 'PO0002',
  /** Ningún código del TXT coincide con productos existentes. `data: { codes }`. */
  NO_CODES_MATCH = 'PO0005',
}

type TranslateFn = (key: string, options?: any) => string;

/**
 * `HandlerError` sin mapa cae en el error generico, asi que el tope de zonas se
 * veria como "ha ocurrido un error" y el operador no sabria que quitar. El
 * backend ya manda un `message` con los numeros, asi que se muestra ese; el
 * texto local solo se usa si viniera vacio.
 *
 * `description` se renderiza con `<Trans i18nKey={...} />`, y una clave que no
 * existe se pinta tal cual: por eso vale pasarle la frase del backend.
 */
export const mapProductDiscountErrors = (t: TranslateFn) => {
  return (error: any): ErrorType | undefined => {
    if (error?.reference === PRODUCT_OFFER_ERROR_REFERENCE.ZONE_LIMIT) {
      return {
        title: 'productDiscount:errors.zoneLimitTitle',
        description:
          error?.message || t('productDiscount:errors.zoneLimit', { zones: error?.data?.zones, max: error?.data?.max }),
        severity: 'error',
      };
    }

    if (error?.reference === PRODUCT_OFFER_ERROR_REFERENCE.NO_CODES_MATCH) {
      return {
        title: 'productDiscount:errors.noCodesMatchTitle',
        description: t('productDiscount:errors.noCodesMatch', { codes: error?.data?.codes?.join(', ') ?? '' }),
        severity: 'error',
      };
    }

    return undefined;
  };
};
